/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor
 */
export interface IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    allowed_types?: Array<string>;
}

/**
 * Check if a given object implements the IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor interface.
 */
export function instanceOfIntegrationEventPccPatientLeadsInnerInsurancesInnerPayor(value: object): value is IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor {
    return true;
}

export function IntegrationEventPccPatientLeadsInnerInsurancesInnerPayorFromJSON(json: any): IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor {
    return IntegrationEventPccPatientLeadsInnerInsurancesInnerPayorFromJSONTyped(json, false);
}

export function IntegrationEventPccPatientLeadsInnerInsurancesInnerPayorFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'allowed_types': json['allowed_types'] == null ? undefined : json['allowed_types'],
    };
}

export function IntegrationEventPccPatientLeadsInnerInsurancesInnerPayorToJSON(json: any): IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor {
    return IntegrationEventPccPatientLeadsInnerInsurancesInnerPayorToJSONTyped(json, false);
}

export function IntegrationEventPccPatientLeadsInnerInsurancesInnerPayorToJSONTyped(value?: IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'allowed_types': value['allowed_types'],
    };
}

